import type { SxProps } from "@mui/material";
import type { ThemeV2 } from "../../util/types";

export const checkBoxStyle = (theme: ThemeV2): SxProps => ({
  position: "relative",
  appearance: "none",
  width: "20px",
  height: "60px",
  margin: 0,
  cursor: "pointer",
  color: theme.tokens.color.action.primary,
  "&.Mui-checked": {
    color: theme.tokens.color.action.primary,
  },
});

export const RadioStyle = (theme: ThemeV2): SxProps => ({
  position: "relative",
  appearance: "none",
  width: "10px",
  height: "10px",
  margin: 0,
  cursor: "pointer",
  color: theme.tokens.color.action.primary,

  "&.Mui-checked": {
    color: theme.tokens.color.action.primary,
  },
});
